import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import SidebarClientes from './SidebarClientes';
import FormNovoCliente from './FormNovoCliente';
import UpdateButton from '../../../Componentes/UpdateButton';
import DeleteButton from '../../../Componentes/DeleteButton';
import InputTextTelefone from '../../../Componentes/InputTextTelefone';
import InputTextEmail from '../../../Componentes/InputTextEmail';
import { Password } from 'primereact/password';
import SidebarDCA from './SidebarDCA';



export default function FormDCAs(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [fieldsFound, setFieldsFound] = useState([]);
    const {idempresa, idcliente} = props
    const carregadoClientes = useRef(false); // Evita múltiplas chamadas
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [dcas, setDcas]= useState(props.dcas);
  

    const [dca, setDca]= useState([]);
    const [edicao, setEdicao]= useState(false);

    

    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        setDcas(props.dcas)
    },[props.dcas])

    useEffect(()=>{
        
        
    },[props.dcas])

    



    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        chavecoletor: { value: '', matchMode: FilterMatchMode.CONTAINS },
        hostname: { value: '', matchMode: FilterMatchMode.EQUALS },
        datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
        dataativacao: { value: '', matchMode: FilterMatchMode.EQUALS },
        dataatualizacao: { value: '', matchMode: FilterMatchMode.EQUALS },
        dcaversao: { value: '', matchMode: FilterMatchMode.EQUALS }
    });
    

    const clearFilters = () => {
            setGlobalFilterValue('');
            setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            chavecoletor: { value: '', matchMode: FilterMatchMode.CONTAINS },
            hostname: { value: '', matchMode: FilterMatchMode.EQUALS },
            datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataativacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataatualizacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dcaversao: { value: '', matchMode: FilterMatchMode.EQUALS }
            });
            setFieldsFound([]); // Resetando os campos encontrados
        };

    

        const renderHeader = () => {
                return (
                    <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                       
                        <div className="flex align-items-center gap-2">
                            <IconField iconPosition="left">
                                <InputIcon className="pi pi-search" />
                                <InputText 
                                    value={globalFilterValue} 
                                    onChange={onGlobalFilterChange} 
                                    placeholder="Pesquisa global" 
                                    tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                                />
                            </IconField>
                            <Button 
                                icon="pi pi-filter-slash" 
                                className="p-button-secondary p-button-sm" 
                                onClick={clearFilters} 
                                tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                            />
                            
                            <Button 
                                icon="pi pi-plus" 
                                className= "p-button-primary p-button-sm" 
                                disabled ={props.fixarCliente}
                                tooltip="Nova Licença" tooltipOptions={{ position: 'bottom' }}
                                onClick={()=>{
                                    if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                           
                                        props.showMessage("warn", 'Datacount - Licença', 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                        return;
                                    }  
                                    confirmDialog({
                                        message: 'Confirma a Criação de uma Chave DCA para o cliente?',
                                        header: 'Confirmação',
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: 'Sim',
                                        rejectLabel: 'Não',
                                        accept: () => {
                                        props.setLoading(true)
                                        props.Conexao.post('dcaController/insertDcaV2', {
                                            ...props.chaveDCA
                                            }).then(response=>{

                                                if(response.status == 200 && response.data.status == 'OK'){

                                                    props.setDcas(prevData => [...prevData, response.data.payload]); 

                                                    props.showMessage('success', 'Cadastro de Licenças', 'Registro inserido com sucesso!') 

                                                }else{

                                                    props.showMessage('warn', 'Cadastro de Licenças', 'Não foi possível inserir registro')  

                                                }

                                                props.setLoading(false)     
                                                                             
                                            }).catch(error=>{

                                                props.showMessage('error', 'Cadastro de Licenças', 'Não foi possível inserir registro')  

                                                props.setLoading(false)   

                                            })

                                            
                                        }
                                        });   
                                }}
                            />            
                        </div>
                        
                    </div>
                );
            };

            const onGlobalFilterChange = (e) => {

                const value = e.target.value;

                setGlobalFilterValue(value);
            
                setFilters(prevFilters => ({
                    ...prevFilters,
                    global: { value, matchMode: FilterMatchMode.CONTAINS }
                }));
            };


            const handleChange = (e) => {

                const { name, value } = e.target;

                setDcas(prevState => ({
                    ...prevState,
                    [name]: value
                }));

            };

    return <div>
             <DataTable
                    value={dcas}
                    header={renderHeader()}
                    paginator                 
                    rows={15} // Número de itens por página
                    rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    tableStyle={{ minWidth: '35rem', fontSize : '10px' }}
                    filters={filters}
                    globalFilterFields={['chave', 'datacadastro', 'dataativacao', 'dataatualizacao', 'hostname', 'dcaversao']}
                    bodyStyle={{fontSize : '10px'}}                            
                    rowClassName={rowData => rowData.ativo === 'f' ? 'row-inativo' : ''}
                >
                     <Column 
                        bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' }} 
                        field="chave" 
                        header="Chave DCA" 
                        name="chave" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                            />

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' }} 
                        field="datacadastro" 
                        header="Criação" 
                        name="datacadastro" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                        />

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' }} 
                        field="dataativacao" 
                        header="Instalação" 
                        name="dataativacao" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                         />

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' }} 
                        field="dataatualizacao" 
                        header="Comunicação" 
                        name="dataatualizacao" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                         />

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' }} 
                        field="hostname" 
                        header="Hostname" 
                        name="hostname" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                         />

                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'12px' }} 
                        field="dcaversao" 
                        header="Versão" 
                        name="dcaversao" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                         />
                    <Column 
                            bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                            headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                            header="Editar"
                            body={(row)=> loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                            <UpdateButton
                                disabled = {row.ativo ==='f' || props.fixarCliente}
                                style={{padding : '2px'}} className='w-full' onClick = {()=>{
                                if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                           
                                    props.showMessage("warn", 'Datacount - Licença', 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                    return;
                                }  
                                setEdicao(true)
                                setDca(row)
                            }}/>}                         
                        />
    
                    <Column 
                            bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px', textAlign:'center' }} 
                            headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                            header="Excluir"
                            body={(row)=> loading ? 
                                        <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> 
                                            : 
                                        <DeleteButton severity="danger" style={{padding : '2px'}} className='w-full'
                                        disabled = {row.ativo ==='f' || row.dataativacao || props.fixarCliente}
                                         onClick={()=>{
                                            if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                           
                                                props.showMessage("warn", 'Datacount - Licença', 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                                return;
                                            }  
                                            
                                            confirmDialog({
                                                message: 'Confirma a EXCLUSÂO essa chave de instalação?',
                                                header: 'Confirmação',
                                                icon: 'pi pi-exclamation-triangle',
                                                acceptLabel: 'Sim',
                                                rejectLabel: 'Não',
                                                accept: () => {
                                                props.setLoading(true)
                                                props.Conexao.post('dcaController/removeDca', {
                                                    idusuario : row.idusuario, 
                                                    idempresa : row.idempresa, 
                                                    idcliente : row.idcliente, 
                                                    iddca : row.iddca
                                                    }).then(response=>{

                                                        if(response.status == 200 && response.data.status == 'OK'){

                                                            props.setDcas(prevData => [...prevData.filter(item => item.iddca !== row.iddca )]); 

                                                            props.showMessage('success', 'Cadastro de Licenças', 'Registro removido com sucesso!')  

                                                        }else{

                                                            props.showMessage('warn', 'Cadastro de Licenças', 'Não foi possível remover registro')  

                                                        }

                                                        props.setLoading(false)      

                                                    }).catch(error=>{

                                                        props.showMessage('error', 'Cadastro de Licenças', 'Não foi possível remover registro')  

                                                        props.setLoading(false)      
                                                                                     
                                                    })
        
                                                    
                                                }
                                                }); 
                                        }}/>}                         
                        />

                </DataTable> 
                <SidebarDCA getDca ={props.getDca} showMessageToast ={props.showMessageToast} dca = {dca} setDca = {setDca} locaisInstalacao = {props.locaisInstalacao} getLocaisByCliente ={props.getLocaisByCliente}/>
    </div>

}